import { create } from 'zustand';

interface NavigationCollapseStoreType {
    /** 是否点击了画布 */
    isClickingStage: boolean;
    /** 设置是否点击了画布 */
    setIsClickingStage: (isClickingStage: boolean) => void;
}

export const useNavigationCollapseStore = create<NavigationCollapseStoreType>((set, get) => ({
    isClickingStage: false,
    setIsClickingStage: (isClickingStage) => set({ isClickingStage }),
}));
